var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 54,
    viewBox: "0 0 89 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(-0.202 0.12)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 26.5,
    cy: 27,
    rx: 26.5,
    ry: 27,
    transform: "translate(0.202 -0.12)",
    fill: "#e30713"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 27.5,
    cy: 27,
    rx: 27.5,
    ry: 27,
    transform: "translate(34.202 -0.12)",
    fill: "#f59e00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M0,20.578A26.85,26.85,0,0,1,9.646,0a27.34,27.34,0,0,1,9.236,20.578A27.34,27.34,0,0,1,9.646,41.157,26.85,26.85,0,0,1,0,20.578Z",
    transform: "translate(34.227 6.567)",
    fill: "#eb5e03"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup31);
export default __webpack_public_path__ + "static/media/Group_31.7f0f4615f3775588ac5e12fc51dafaad.svg";
export { ForwardRef as ReactComponent };